import { Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withMountListener, withRenderFlag } from '@beef/react';
import { ActionSearch } from "./store/slices/search/actions";
import { SearchFieldButton } from "./components/SearchFieldButton";
import { fetchQuantity, handleClickCart } from "./store/slices/cart/actions";
import { selectCartQuantity, selectHasCart } from "./store/slices/cart/selectors";
import { Cart } from "./components/Cart";
import { selectCategoriesLinks, selectCurrentCategory, selectIsModalStepMenu, selectIsModalStepSearch, withMenuCategoriesMapper } from "./store/slices/menu/selectors";
import { selectHeaderTheme, selectIsOverlayDisabled, selectIsWebView } from "./store/slices/layout/selectors";
import { toggleRegionModal as _toggleRegionModal } from "./store/slices/region";
import { selectCurrentUserRegion } from "./store/slices/region/selectors";
import { toggleModalMenu as _toggleModalMenu } from "./store/slices/menu";
import { AdditionalLinks } from "./components/AdditionalLinks";
import { Menu } from "./components/Menu";
import { Region } from "./components/Region";
import { CategoriesList } from "./components/MenuModal/components/Mobile/components/Categories/components/CategoriesList";
import { CategoriesItem } from "./components/MenuModal/components/Mobile/components/Categories/components/CategoriesItem";
import { Login } from "./components/Login";
import { CategoriesLinks } from "./components/MenuModal/components/Mobile/components/Categories/components/CategoriesLinks";
import { Layout } from "./components/Layout";
import { TopBanner } from "./components/TopBanner";
import { loginClick, selectAdditionalLinks, selectHeaderCommonData, selectHttpCookie } from "./store/common";
import { ECurrentModalStep } from "./store/types";
import { AnimationWrapper } from "./components/MenuModal/components/Mobile/components/AnimationWrapper";
import { setIsBannerHidden as _setIsBannerHidden, setIsRegionConfirmationShow } from "./store/slices/layout";
import { BreakpointProvider } from "../../components/BreakpointProvider";
import { ShareButton } from "./components/ShareButton";
export var CategoriesListRC = withMenuCategoriesMapper(CategoriesList);
export var CategoriesItemRC = connect(function (state) {
  return {
    category: selectCurrentCategory(state)
  };
})(CategoriesItem);
export var CategoriesLinksRC = compose(connect(function (state) {
  return {
    links: selectCategoriesLinks(state),
    shouldRender: selectCategoriesLinks(state).length
  };
}), withRenderFlag)(CategoriesLinks);
export var TopBannerRC = compose(connect(function (state) {
  return {
    banner: selectHeaderCommonData(state).topBanner,
    shouldRender: !!selectHeaderCommonData(state).topBanner,
    cookie: selectHttpCookie(state)
  };
}, function (dispatch) {
  return {
    setIsBannerHidden: function setIsBannerHidden(bannerState) {
      return dispatch(_setIsBannerHidden(bannerState));
    }
  };
}), withRenderFlag)(TopBanner);
export var AdditionalLinksRC = connect(function (state) {
  return {
    additionalLinks: selectAdditionalLinks(state),
    headerTheme: selectHeaderTheme(state)
  };
})(AdditionalLinks);
export var LayoutRC = connect(function (state) {
  return {
    headerTheme: selectHeaderTheme(state)
  };
})(Layout);
export var LayoutContainerRC = connect(function (state) {
  return {
    headerTheme: selectHeaderTheme(state),
    overlayDisabled: selectIsOverlayDisabled(state)
  };
})(Layout.Container);
export var RegionRC = connect(function (state) {
  return {
    userRegion: selectCurrentUserRegion(state),
    headerTheme: selectHeaderTheme(state)
  };
}, function (dispatch) {
  return {
    toggleRegionModal: function toggleRegionModal() {
      return dispatch(_toggleRegionModal());
    },
    onRegionConfirmationShow: function onRegionConfirmationShow() {
      return dispatch(setIsRegionConfirmationShow(true));
    },
    onRegionConfirmationClose: function onRegionConfirmationClose() {
      return dispatch(setIsRegionConfirmationShow(false));
    }
  };
})(Region);
export var MenuRC = connect(function (state) {
  return {
    headerTheme: selectHeaderTheme(state)
  };
}, function (dispatch) {
  return {
    toggleModalMenu: function toggleModalMenu() {
      return dispatch(_toggleModalMenu());
    }
  };
})(Menu);
export var LoginRC = connect(function (state) {
  var _selectHeaderCommonDa;
  return {
    user: (_selectHeaderCommonDa = selectHeaderCommonData(state).auth) === null || _selectHeaderCommonDa === void 0 ? void 0 : _selectHeaderCommonDa.user,
    headerTheme: selectHeaderTheme(state)
  };
}, {
  onClick: loginClick
})(Login);
export var CartRC = compose(connect(function (state) {
  return {
    quantity: selectCartQuantity(state),
    headerTheme: selectHeaderTheme(state),
    shouldRender: selectHasCart(state)
  };
}, {
  onClick: handleClickCart,
  onMount: fetchQuantity
}), withMountListener, withRenderFlag)(Cart);
export var MenuAnimationWrapperRC = connect(function (state) {
  return {
    isVisible: selectIsModalStepMenu(state),
    keyRender: ECurrentModalStep.menu
  };
})(AnimationWrapper);
export var SearchAnimationWrapperRC = connect(function (state) {
  return {
    isVisible: selectIsModalStepSearch(state),
    keyRender: ECurrentModalStep.search
  };
})(AnimationWrapper);
export var BreakpointProviderRC = connect(function (state) {
  return {
    isMobileDevice: selectHeaderCommonData(state).isMobileDevice
  };
})(BreakpointProvider);
export var Browser = compose(connect(function (state) {
  return {
    shouldRender: !selectIsWebView(state)
  };
}), withRenderFlag)(Fragment);
export var WebView = compose(connect(function (state) {
  return {
    shouldRender: selectIsWebView(state)
  };
}), withRenderFlag)(Fragment);
export var EnvRC = {
  Browser: Browser,
  WebView: WebView
};
export var SearchFieldButtonRC = connect(function (state) {
  return {
    headerTheme: selectHeaderTheme(state)
  };
}, {
  onClick: ActionSearch.showSearchModal
})(SearchFieldButton);
export var ShareButtonRC = connect(function (state) {
  return {
    headerTheme: selectHeaderTheme(state),
    shareLink: selectHeaderCommonData(state).shareLink
  };
})(ShareButton);